import {t} from "react-multi-lang";
import {Dispatch} from "redux";
import * as io from "socket.io-client";
import {
    ADD_SHORTLIST,
    ADD_SOURCE as ADD,
    CONNECT,
    DISCONNECT,
    EDIT_SOURCE,
    GET_INSTANCE,
    REMOVE_SHORTLIST,
    REMOVE_SOURCE,
    SOURCE_ID
} from "../action_types/ioActionTypes";
import {
    ADD_SOURCE, ADD_SOURCES, DELETE_SOURCES, SHORTLIST_ADD, SHORTLIST_REMOVE, UPDATE_ID, UPDATE_SOURCE
} from "../action_types/literatureWizardActionTypes";
import config from "../config";
import {resetCredentials, setCredentials} from "./credentialActions";
import {resetSources} from './literatureWizardActions';
import {hideNotification, showLoading, showNotification} from "./notificationActions";

const {SERVER_ADDRESS, SOCKET_PATH} = config;

export function incomingEventHandler(eventType: string, params: any) {
    return (dispatch: Dispatch) => {
        switch (eventType) {
            case GET_INSTANCE: {
                dispatch({
                    instance: params,
                    type: ADD_SOURCES,
                });

                dispatch({
                    type: eventType
                });
                hideNotification()(dispatch);
                break;
            }

            case SOURCE_ID: {
                dispatch({
                    source: {...params.source, old_id: params.old_id},
                    type: UPDATE_ID
                });
                break;
            }

            case ADD: {
                dispatch({
                    source: params,
                    type: ADD_SOURCE
                });
                break;
            }

            case EDIT_SOURCE: {
                dispatch({
                    source: params,
                    type: UPDATE_SOURCE
                });
                break;
            }

            case ADD_SHORTLIST: {
                dispatch({
                    elementType: params.type,
                    type: SHORTLIST_ADD,
                    value: params.value
                });
                break;
            }

            case REMOVE_SHORTLIST: {
                dispatch({
                    elementType: params.type,
                    type: SHORTLIST_REMOVE,
                    value: params.value
                });
                break;
            }

            case REMOVE_SOURCE: {
                dispatch({
                    ids: params,
                    type: DELETE_SOURCES,
                });
                break;
            }

            default:
                break;
        }
    };
}

let cancelLogin: (() => void) | undefined;

export function connectInstance(instanceID: string, password: string) {
    return (dispatch: Dispatch) => {
        if (cancelLogin) {
            cancelLogin();
        }
        setCredentials(instanceID, password)(dispatch);
        showLoading()(dispatch);

        let closed = false;
        let loaded = false;
        let socket: SocketIOClient.Socket | undefined;
        const regSocket = io.connect(SERVER_ADDRESS, {forceNew: true, path: SOCKET_PATH});
        const cleanup = () => {
            closed = true;
            clearTimeout(timer);
            regSocket.disconnect();
            if (socket) {
                socket.disconnect();
            }
        };
        const fail = (key: string) => {
            if (closed) {
                return;
            }
            cleanup();
            // Do not immediately retry saved credentials when the login screen mounts.
            resetCredentials()(dispatch);
            dispatchDisconnect()(dispatch);
            showNotification(t('login.' + key), true)(dispatch);
        };
        const timer = setTimeout(() => fail('timeout'), 20000);
        cancelLogin = cleanup;
        const watchErrors = (connection: SocketIOClient.Socket) => {
            connection.on('connect_error', () => fail('connection_error'));
            connection.on('connect_timeout', () => fail('timeout'));
            connection.on('error', () => fail('connection_error'));
        };
        watchErrors(regSocket);
        regSocket.on('disconnect', () => {
            if (!socket) {
                fail('connection_error');
            }
        });
        regSocket.once('connect', () => {
            regSocket.emit('register', {instanceID, password});
        });
        regSocket.once('register', (success: boolean) => {
            if (closed) {
                return;
            }
            if (!success) {
                return fail('authentication_error');
            }

            // Match the backend's querystring.escape encoding, including / and #.
            socket = io.connect(`${SERVER_ADDRESS}/${encodeURIComponent(instanceID)}`, {
                forceNew: true, path: SOCKET_PATH
            });
            const projectSocket = socket;
            regSocket.disconnect();
            watchErrors(projectSocket);
            projectSocket.on('disconnect', () => fail('connection_error'));
            projectSocket.on('unauthorized', () => fail('authentication_error'));
            projectSocket.on('instance_error', () => fail('load_error'));
            projectSocket.on(GET_INSTANCE, (params: any) => {
                if (closed) {
                    return;
                }
                loaded = true;
                clearTimeout(timer);
                incomingEventHandler(GET_INSTANCE, params)(dispatch);
            });
            projectSocket.on(SOURCE_ID,
                (params: any) => incomingEventHandler(SOURCE_ID, params)(dispatch));
            projectSocket.on(ADD,
                (params: any) => incomingEventHandler(ADD, params)(dispatch));
            projectSocket.on(EDIT_SOURCE,
                (params: any) => incomingEventHandler(EDIT_SOURCE, params)(dispatch));
            projectSocket.on(ADD_SHORTLIST,
                (params: any) => incomingEventHandler(ADD_SHORTLIST, params)(dispatch));
            projectSocket.on(REMOVE_SHORTLIST,
                (params: any) => incomingEventHandler(REMOVE_SHORTLIST, params)(dispatch));
            projectSocket.on(REMOVE_SOURCE,
                (params: any) => incomingEventHandler(REMOVE_SOURCE, params)(dispatch));
            projectSocket.on('authenticated', () => {
                if (closed || loaded) {
                    return;
                }
                dispatchConnect(projectSocket)(dispatch);
                projectSocket.emit(GET_INSTANCE);
            });
            projectSocket.on('connect', () => {
                projectSocket.emit('authentication', {instanceID, password});
            });
        });
    };
}

export function disconnectInstance() {
    return (dispatch: Dispatch, getState: any) => {
        const state = getState();
        const nsp = state.io.socket;

        if (cancelLogin) {
            cancelLogin();
        }
        if (nsp) {
            nsp.disconnect();
        }
        resetCredentials()(dispatch);
        resetSources()(dispatch);
        dispatchDisconnect()(dispatch);
    };
}

function dispatchConnect(socket: SocketIOClient.Socket) {
    return (dispatch: Dispatch) => {
        dispatch({
            socket,
            type: CONNECT
        });
    };
}

function dispatchDisconnect() {
    return (dispatch: Dispatch) => {
        dispatch({
            type: DISCONNECT
        });
    };
}



// WEBPACK FOOTER //
// ./src/actions/ioActions.ts